import {DateTime} from 'luxon';
import {PatternShift} from '../pattern/pattern-shift';

export class SchedulePreview {
  private _date: DateTime;
  private _isWorkingDay: boolean;
  private _shifts: PatternShift[];

  public constructor(date: DateTime, isWorkingDay: boolean, shifts: PatternShift[]) {
    this._date = date;
    this._isWorkingDay = isWorkingDay;
    this._shifts = shifts;
  }

  public get date(): DateTime {
    return this._date;
  }

  public get isWorkingDay(): boolean {
    return this._isWorkingDay;
  }

  public get shifts(): PatternShift[] {
    return this._shifts;
  }
}
